
<template>
<!-- Footer -->
 <footer class="footer">
   <div class="footer-container">
     <div class="footer-top">
       <div class="footer-left">
         <img src="@/assets/imgs/web/weblogo.png" alt="ALULA Logo" class="footer-logo" />
         <p class="footer-description l" v-html="$i18n.locale=='en' ? footer_data?.elements?.find(e => e.slug=='text-footer-1')?.content_en : footer_data?.elements?.find(e => e.slug=='text-footer-1')?.content_ar"></p>
         <div class="footer-contact l" v-if="footer_data?.elements?.find(e =>e.slug=='card-footer-2')"> 
          <div class="l" v-for="item in footer_data?.elements?.find(e =>e.slug=='card-footer-2')?.sub_elements">
            <p v-html="$i18n.locale=='en' ? item?.content_en : item?.content_ar"></p>
          </div>
          
           <!-- <p><img src="@/assets/imgs/web/locationf.png" class="foo-icon-img" /> AlUla, Kingdom of Saudi Arabia</p>
           <p><img src="@/assets/imgs/web/email.png" class="foo-icon-img" /> info@alulaeme.com</p>
           <p><img src="@/assets/imgs/web/call.png" class="foo-icon-img" /> +966 12 345 6789</p> -->
         </div>
       </div>

       <div class="footer-links-section">
         <div class="footer-column l">
           <h4>{{ $t('Quick links') }}</h4>
           <ul>
         <!-- <router-link v-for="el in link_list"  :to="{ path: el.navigation_route }" class="nav-link" :class="{ 'active': $route.path == el.navigation_route }" @click="closeMenu">{{ $i18n.locale=='en' ? el.title_en : el.title_ar }}</router-link>  -->

             <li v-for="el in link_list">
              <router-link :to="{ path: el.navigation_route }">{{ $i18n.locale=='en' ? el.title_en : el.title_ar }}</router-link></li>
             <!-- <li><router-link :to="{ name: 'aboutpage' }">{{ $t('About') }}</router-link></li> -->
             <!-- <li><router-link :to="{ name: 'agendapage' }">{{ $t('Agenda') }}</router-link></li>
             <li><router-link :to="{ name: 'speakerpage' }">{{ $t('Speakers') }}</router-link></li> -->
             <!-- <li> <a href="#livestream">Live stream</a></li> -->
           </ul>
         </div>

         <!-- <div class="footer-column l">
           <h4>{{ $t('Resources') }}  </h4>
           <ul>
             <li><router-link :to="{ name: 'highlightpage' }">{{ $t('Highlights') }}</router-link></li>
             <li><router-link :to="{ name: 'faqpage' }">{{ $t('FAQs') }}</router-link></li>
             <li><router-link :to="{ name: 'contactpage' }">{{ $t('Contact Us') }}</router-link></li>
             <li><router-link :to="{ name: 'researchpage' }">{{ $t('Research') }}</router-link></li>
              <li><router-link :to="{ name: 'mediapage' }">{{ $t('Media library') }}</router-link></li>
             <li><a href="#privacy">Privacy Policy</a></li>
             <li><a href="#terms">Terms of service</a></li>
           </ul>
         </div> -->
       </div>

       <div class="footer-right">
        <router-link :to="{ name: 'contactpage' }">
         
        <button class="get-in-touch-btn">
          <span class="vm">{{ $t('Get in touch') }} </span>
          <svg class="vm" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40"><path fill="#C7A879" :d="$i18n.locale=='en' ? 'M24.73 28.146a.5.5 0 0 0 .36-.153l7.359-7.631a.5.5 0 0 0 0-.693l-7.391-7.662a.5.5 0 1 0-.72.693l7.056 7.315l-7.024 7.284a.5.5 0 0 0 .36.847' : 'M15.27 11.854a.5.5 0 0 0-.36.153l-7.359 7.631a.5.5 0 0 0 0 .693l7.391 7.662a.5.5 0 1 0 .72-.693l-7.056-7.315l7.024-7.284a.5.5 0 0 0-.36-.847'" stroke-width="1" stroke="#C7A879"/><path fill="#C7A879" :d="$i18n.locale=='en' ? 'M7.91 20.515h24.18a.5.5 0 0 0 0-1H7.91a.5.5 0 0 0 0 1' : 'M32.09 19.485H7.91a.5.5 0 0 0 0 1h24.18a.5.5 0 0 0 0-1'" stroke-width="1" stroke="#C7A879"/></svg>
         </button>
         </router-link>
         <div class="organizers">
          <div>
            <img src="@/assets/imgs/web/alula_logos_banner_ar.png" alt="IMF" class="org-logox"  v-if="$i18n.locale=='ar'" style="width: 100%; height: auto; max-width: 480px;"/>
              <img src="@/assets/imgs/web/alula_logos_banner.png" alt="IMF" class="org-logox"  v-else style="width: 100%; height: auto; max-width: 480px;"/>
          </div>
          <!-- <div>
            
            <div class="c">
              <img src="@/assets/imgs/web/group1.png" alt="" class="w100 g_nm" v-if="$i18n.locale=='en'" style="max-width: 480px;">
              <img src="@/assets/imgs/web/group2.png" alt="" class="w100 g_nm" v-if="$i18n.locale=='ar'" style="max-width: 480px;">
            </div>
            <div class="c vm g_nm w33 p10">
              <a href="https://www.alarabiya.net/aswaq" target="_blank">
              <img src="@/assets/imgs/web/news/1.png" alt="IMF" class="w100 g_nm" style="max-width: 140px;"/>
              </a>
            </div>
              <div class="c vm g_nm w33 p10">
                <a href="https://edition.cnn.com/" target="_blank">
                  <img src="@/assets/imgs/web/news/2.png" alt="IMF" class="w100 g_nm" style="max-width: 140px;"/>
                </a>
              </div>
                  
              <div class="c vm g_nm w33 p10">
                <a href="https://asharq.com/" target="_blank">
                  <img src="@/assets/imgs/web/news/4.png" alt="IMF" class="w100 g_nm" style="max-width: 140px;"/>
                </a>
              </div>
          </div> -->
          <!-- <tbl>
            <cl class="w33 vm">
              
            </cl>
            <cl class="colSep30"></cl>
            <cl class="w66 vm">
              
            </cl>
          </tbl> -->
           <!-- <div class="organizer-logos">
            <div>
              <img src="@/assets/imgs/web/alula_logos_banner_ar.png" alt="IMF" class="org-logo"  v-if="$i18n.locale=='ar'"/>
              <img src="@/assets/imgs/web/alula_logos_banner.png" alt="IMF" class="org-logo"  v-else/>
            </div>
             <div>
              
             </div>
           </div> -->
         </div>
         
       </div>
     </div>

     <div class="footer-bottom">
       <div class="social-icons">
         <a v-if="footer_data?.elements?.find(e => e.slug =='card-footer-4')" :href="footer_data?.elements?.find(e => e.slug =='card-footer-4')?.sub_elements[1]?.link" target="_blank"  class="social-icon"><img :src="footer_data?.elements?.find(e => e.slug =='card-footer-4')?.sub_elements[0]?.image" class="foosocialimg" /></a>
         <a v-if="footer_data?.elements?.find(e => e.slug =='card-footer-5')" :href="footer_data?.elements?.find(e => e.slug =='card-footer-5')?.sub_elements[1]?.link" target="_blank"  class="social-icon"><img :src="footer_data?.elements?.find(e => e.slug =='card-footer-5')?.sub_elements[0]?.image" class="foosocialimg" /></a>
         <a v-if="footer_data?.elements?.find(e => e.slug =='card-footer-6')" :href="footer_data?.elements?.find(e => e.slug =='card-footer-6')?.sub_elements[1]?.link" target="_blank"  class="social-icon"><img :src="footer_data?.elements?.find(e => e.slug =='card-footer-6')?.sub_elements[0]?.image" class="foosocialimg" /></a>
         <a v-if="footer_data?.elements?.find(e => e.slug =='card-footer-7')" :href="footer_data?.elements?.find(e => e.slug =='card-footer-7')?.sub_elements[1]?.link" target="_blank"  class="social-icon"><img :src="footer_data?.elements?.find(e => e.slug =='card-footer-7')?.sub_elements[0]?.image" class="foosocialimg" /></a>
       </div>
       <p class="copyright" v-html="$i18n.locale=='en' ? footer_data?.elements?.find(e => e.slug=='text-footer-3')?.content_en : footer_data?.elements?.find(e => e.slug=='text-footer-3')?.content_ar">
      </p>
        <!-- © 2026 AlUla Emerging Market Economies Conference. All rights reserved. -->

     </div>
   </div>
 </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    link_list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      footer_data: {},
    };
  },
  mounted() {
    const url = this.$store.state.baseApiUrl + 'web-content/get-section-by-slug'
      const payload = { section_slug: 'footer' }
      
      this.axios.post(url, payload)
        .then(response => {
          this.footer_data= response.data.data
        })
        .catch(error => {
          console.error('Error fetching page data:', error)
        })
  }
}


</script>

<style scoped>
/* Footer Styles */
.footer {
  background: #3F2416;
  color: #ffffff;
  padding: 60px 0 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-align: left;
}
img.foosocialimg {
    width: 40px;
}
.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-top {
  display: grid;
  grid-template-columns: 1.3fr 1.2fr 1.2fr;
  gap: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
  place-items: start;
}

.footer-logo {
  height: 70px;
  width: auto;
  object-fit: contain;
  margin-bottom: 10px;
}

.footer-description {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  font-size: 0.95rem;
  margin: 0;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.footer-contact p {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
  margin: 0;
  white-space: pre-line;
}
img.foo-icon-img {
    width: 20px;
}
.footer-contact i {
  width: 16px;
  opacity: 0.7;
}

.footer-links-section {
  display: flex;
  gap: 80px;
}

.footer-column h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #ffffff;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-column ul li a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

.footer-column ul li a:hover {
  color: #ffffff;
}

.footer-right {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer-right h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
  color: #ffffff;
}

.organizers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.organizer-logos {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}
.organizer-logos div{
  width: calc(50% - 10px);
}
.org-logo {
  height: 150px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.media_logo {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  display: block;
}

.ministry-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.ministry-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  text-align: center;
}

.get-in-touch-btn {
  background: #ffffff;
  color: #4a352a;
  border: none;
  padding: 14px 32px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
      align-self: end;
}
.get-in-touch-btn svg, .get-in-touch-btn svg *{
  fill: #4a352a;
  stroke: #4a352a;
  transition: all 0.3s ease;
}
.get-in-touch-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.get-in-touch-btn:hover svg, .get-in-touch-btn:hover svg *{
  /* fill: #3F2416;
  stroke: #3F2416; */
}

.get-in-touch-btn span {
  font-size: 1.2rem;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
}

.social-icons {
  display: flex;
  gap: 12px;
}

.social-icon {

  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.social-icon:hover {
  /* background: rgba(255, 255, 255, 0.2); */
  transform: translateY(-3px);
}

.copyright {
  color: rgba(255, 255, 255, 0.878);
  font-size: 0.85rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .footer-right {
    grid-column: 1 / -1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .footer-links-section {
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 20px;
  }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-links-section {
    flex-direction: column;
    gap: 30px;
  }

  

  .get-in-touch-btn {
    align-self: stretch;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .social-icons {
    justify-content: center;
  }
  .org-logo{
    height: 120px;
  }
  .media_logo{
    height: 60px;}
}
@media (max-width: 1024px) {
  .footer-right {
    flex-direction: column;
    align-items: stretch;
  }

  .footer-right h3 {
    text-align: left;
  }

  .organizers {
    justify-content: flex-start;
  }
}
@media (max-width: 768px) {
  .organizer-logos{
    flex-direction: column;
    gap:10px;
    align-items: start;
  }
.organizer-logos div{
    width: 100%;
  }
  .media_logo{
    max-width: 220px;
    height: auto;
  }
}
</style>